import { TabInterface } from '../../../Interfaces/TabInterface'
import { Icon } from '../../Elements'

const Tab = ({
  keyItem,
  className,
  title,
  index,
  icon,
  onClick,
}: TabInterface) => {
  return (
    <>
      <div
        onClick={() => {
          onClick(keyItem)
        }}
        className={`  ${
          className?.className ?? ''
        }  flex justify-center items-center flex-col relative py-1
        ${
          index
            ? 'before:w-full before:absolute before:h-[2px] before:bg-warn before:bottom-0'
            : null
        }`}
      >
        <Icon
          icon={icon}
          className={` w-full h-full  text-white ${className?.iconClass ?? ''}`}
        />
        <span className={`${className?.titleClass ?? ''}  text-white`}>
          {title}
        </span>
      </div>
    </>
  )
}

export default Tab
